import { css } from '@emotion/core';
import styled from '@emotion/styled';
import MediaQueries from '../../../styles/Grid/MediaQueries';
import { typography } from '../../../styles/typography';
import { colorsPalette } from '../../../styles/colors';

export const containerPaddingCss = css({
  paddingTop: 64,
  paddingBottom: 64,
  [MediaQueries.mdAndUp]: {
    paddingTop: 96,
    paddingBottom: 96,
  },
});

export const containerMarginCss = css({
  marginTop: 64,
  marginBottom: 64,
  [MediaQueries.mdAndUp]: {
    marginTop: 96,
    marginBottom: 96,
  },
});

export const pictureCss = css({
  display: 'block',
  lineHeight: 0,
  width: 44,
  height: 44,
  borderRadius: '50%',
  overflow: 'hidden',
});

export const imageCss = css({
  width: '100%',
  height: 'auto',
});

export const Content = styled.div({
  paddingLeft: 44,
  [MediaQueries.mdAndUp]: {
    paddingLeft: 15,
  },
});

export const PictureContainer = styled.div({
  marginRight: 15,
});

export const InitialQuote = styled.span({
  position: 'absolute',
  left: -16,
});

export const QuoteText = styled.div({
  ...typography.effra28,
  color: colorsPalette.grey,
  position: 'relative',
});

export const Footer = styled.div({
  display: 'flex',
  marginTop: 25,
});

export const FooterText = styled.div({
  marginTop: 4,
});

export const AttributionMainText = styled.div({
  color: colorsPalette.teal,
  marginBottom: 6,
});

export const AttributionSecondaryText = styled.div({
  color: colorsPalette.grey80,
});
